;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"fdd52e479b0b2c88ef9d19daaa3adbe7129f11db"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/backoffice/v1.3.0-fdd52e479b0b2c88ef9d19daaa3adbe7129f11db";import * as Sentry from '@sentry/nextjs';

const DSN_STAGING =
  'https://eed3a9669bcb49cfa2abdc017b853ca4@o216259.ingest.us.sentry.io/2290372';

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_URL || DSN_STAGING;

const isStaging = SENTRY_DSN === DSN_STAGING;

Sentry.init({
  dsn: SENTRY_DSN,
  environment: isStaging ? 'staging' : 'production',
  ignoreErrors: [
    'gtag is not defined',
    'gtag',
    'Cancel rendering route',
    'The operation is insecure.',
    /ResizeObserver/,
    'Fetch is aborted',
    'Non-Error promise rejection captured with value: Ignore this error'
  ],
  tracesSampleRate: isStaging ? 0 : 0.1
});
